import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import Logout from '../login/Logout';
import { getAuthValue } from '../../lib/authSession';

const SECCIONES = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'accesos', label: 'Accesos' },
  { id: 'servicios', label: 'Servicios' },
  { id: 'nosotros', label: 'Nosotros' },
  { id: 'obras-sociales', label: 'Obras sociales' },
  { id: 'como-sacar-turno', label: 'Cómo sacar turno' },
  { id: 'contacto', label: 'Contacto' },
];

const OPCIONES_LOGIN = [
  { label: 'Como paciente', path: '/login/paciente', icon: 'bi-person-heart' },
  { label: 'Como profesional', path: '/login/profesional', icon: 'bi-briefcase-medical' },
];

const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLogged = getAuthValue("auth");
  const isOnLanding = location.pathname === '/inicio' || location.pathname === '/inicio/';
  const [showLoginDropdown, setShowLoginDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target) && buttonRef.current && !buttonRef.current.contains(e.target)) {
        setShowLoginDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleScrollClick = (e, id) => {
    if (isOnLanding) {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/inicio#${id}`);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <div className="container-fluid">
        <Link className="navbar-brand" to={isLogged && (getAuthValue('userRol') === 'profesional' ? '/profesional' : getAuthValue('userRol') === 'gestor' ? '/gestor_consultorio' : ['admin', 'gestor'].includes(getAuthValue('userRol') || '') ? '/inicio_admin' : '/inicio')}>
          Ridens
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Menú</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body menu">
            <ul className="navbar-nav me-auto">
              {SECCIONES.map(({ id, label }) => (
                <li key={id} className="nav-item">
                  <NavLink
                    to={`/inicio#${id}`}
                    onClick={(e) => handleScrollClick(e, id)}
                    className={({ isActive }) => `nav-link ${isOnLanding && !location.hash && id === 'inicio' ? 'active' : location.hash === `#${id}` ? 'active' : ''}`}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <ul className="navbar-nav">
              {isLogged ? (
                <>
                  <li className="nav-item">
                    <NavLink to="/inicio/realizar_reserva" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                      <i className="bi bi-calendar-plus"></i> Reservar
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/inicio/mis_reservas" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                      <i className="bi bi-journal-bookmark"></i> Mis Reservas
                    </NavLink>
                  </li>
                  {getAuthValue('userRol') === 'responsable' && (
                    <>
                      <li className="nav-item" title="Vincularse con un paciente que ya está registrado">
                        <NavLink to="/inicio/solicitar_vinculacion" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                          <i className="bi bi-link-45deg"></i> Vincular paciente existente
                        </NavLink>
                      </li>
                    </>
                  )}
                  <li className="nav-item">
                    <NavLink to="/inicio/configuracion_cuenta" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
                      <i className="bi bi-person"></i> Mi Cuenta
                    </NavLink>
                  </li>
                  <li className="nav-item logout">
                    <Logout />
                  </li>
                </>
              ) : (
                <li className="nav-item dropdown" ref={dropdownRef}>
                  <button
                    ref={buttonRef}
                    type="button"
                    className="nav-link dropdown-toggle"
                    onClick={(e) => { e.stopPropagation(); setShowLoginDropdown(!showLoginDropdown); }}
                    aria-expanded={showLoginDropdown}
                  >
                    <i className="bi bi-person"></i> Iniciar sesión
                  </button>
                  {showLoginDropdown && createPortal(
                    <ul
                      className="dropdown-menu dropdown-menu-end show"
                      style={buttonRef.current ? (() => {
                        const rect = buttonRef.current.getBoundingClientRect();
                        return {
                          position: 'fixed',
                          zIndex: 1060,
                          top: rect.bottom + 2,
                          right: window.innerWidth - rect.right,
                          left: 'auto',
                          minWidth: 180,
                        };
                      })() : { position: 'fixed', zIndex: 1060, top: 60, right: 16, minWidth: 180 }}
                    >
                      {OPCIONES_LOGIN.map((op) => (
                        <li key={op.label}>
                          <Link
                            to={op.path}
                            className="dropdown-item d-flex align-items-center gap-2"
                            onClick={() => { setShowLoginDropdown(false); }}
                          >
                            {op.icon && <i className={`bi ${op.icon}`} />}
                            {op.label}
                          </Link>
                        </li>
                      ))}
                    </ul>,
                    document.body
                  )}
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
